var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal series-edit-modal",
      attrs: {
        id: "series-edit-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "series-edit-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.series_edit.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c("div", { staticClass: "series-edit-modal__form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-title-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesTitle,
                    expression: "seriesTitle"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "series-title-input",
                  placeholder: _vm.$t(
                    "publishers.modal.new_series.name_placeholder"
                  )
                },
                domProps: { value: _vm.seriesTitle },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesTitle = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-price-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("publishers.modal.series_edit.price")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesPrice,
                    expression: "seriesPrice"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  id: "series-price-input",
                  step: "1000",
                  min: "0",
                  placeholder: _vm.$t(
                    "publishers.modal.series_edit.price_placeholder"
                  )
                },
                domProps: { value: _vm.seriesPrice },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesPrice = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600",
                  attrs: { for: "series-card-price-input" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.series_edit.card_price")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.seriesCardPrice,
                    expression: "seriesCardPrice"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  id: "series-card-price-input",
                  step: "100",
                  min: "0",
                  placeholder: _vm.$t(
                    "publishers.modal.series_edit.card_price_placeholder"
                  )
                },
                domProps: { value: _vm.seriesCardPrice },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.seriesCardPrice = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass:
                    "typography--body-3 typography--color-secondary typography--font-weight-600"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("publishers.modal.series_edit.share_level")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c(
                    "ToggleSwitch",
                    {
                      attrs: {
                        "model-value": _vm.seriesShareLevel,
                        "check-value": 1,
                        id: "share-level-switch"
                      },
                      on: { change: _vm.toggleShareLevel }
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getShareLevelLabel(_vm.seriesShareLevel || 2)
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-422b0494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-422b0494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/SeriesEditModal.vue
// module id = Lqim
// module chunks = 1